import * as React from "react";
import {
  ActivityFragment,
  CompanyMinimalFragment,
  TemplateFragment,
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { timeAgoLabel } from "../../../utils/timeAgo";
import { TemplateIcon } from "../../icons";
import { Link } from "../../wombat-ui";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type TemplateUpdatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: TemplateFragment;
};

export function isTemplateUpdatedActivity(
  q: ActivityFragment
): q is TemplateUpdatedActivity {
  return q.key === "template.updated";
}

interface TemplateUpdatedActivityProps {
  activity: TemplateUpdatedActivity;
}

export const TemplateUpdatedActivity: React.FC<TemplateUpdatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="templateUpdatedActivity"
      visual={<TemplateIcon iconClassName="w-10 h-10 text-accent-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.templateUpdated", {
          template: (
            <Link
              to={`/templates/${activity.trackable.slug}/edit`}
              key={activity.id}
            >
              {t("activity.objects.template")}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
